import React from 'react'
import { Box, TextField, InputAdornment } from '@mui/material'

interface LoginFormInputProps {
    type: string
    name: string
    placeholder: string
    value: string
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    onLoginEnterKey?: (event: React.KeyboardEvent<HTMLDivElement>) => void
    startIcon: React.ReactNode
    endIcon?: React.ReactNode
    autoFocus?: boolean
    error?: boolean
    helperText?: string
    dataCy?: string
    readOnly?: boolean
}

const LoginFormInput: React.FC<LoginFormInputProps> = ({
    type,
    name,
    placeholder,
    value,
    handleChange,
    onLoginEnterKey,
    startIcon,
    endIcon,
    autoFocus = false,
    error = false,
    helperText,
    dataCy,
    readOnly = false,
}) => {
    const reactId = React.useId()
    const inputId = `input-${name}-${reactId}`

    return (
        <Box
            sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
            <Box
                sx={{
                    height: '100%',
                    position: 'absolute',
                    left: '14px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    borderRight: '1px solid #888',
                    padding: '10px 0',
                    paddingRight: '12px',
                    zIndex: 1,
                }}
            >
                {startIcon}
            </Box>
            <TextField
                size="small"
                variant="outlined"
                fullWidth
                name={name}
                type={type}
                value={value}
                onChange={handleChange}
                onKeyDown={(e) => onLoginEnterKey?.(e)}
                required
                autoComplete="off"
                placeholder={placeholder}
                autoFocus={autoFocus}
                error={error}
                helperText={helperText}
                slotProps={{
                    htmlInput: {
                        id: inputId,
                        'data-cy': dataCy ?? ``,
                        'aria-label': name,
                        sx: {
                            '&::placeholder': {
                                color: 'custom.hintText',
                                opacity: 1,
                            },
                        },
                    },
                    input: {
                        endAdornment: endIcon ? (
                            <InputAdornment position="end">
                                {' '}
                                {endIcon}{' '}
                            </InputAdornment>
                        ) : null,
                        sx: {
                            height: '40px',
                            pl: '38px',
                            '& .MuiInputAdornment-root svg': {
                                width: '18px',
                            },
                        },
                    },
                }}
            />
        </Box>
    )
}

export default LoginFormInput
